import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconShoppingCart } from '@redteclab/icons'

import { LoadingButton } from 'base-ui'

import { useProductAddToCartButtonTracking } from './useProductAddToCartButtonTracking'

import styles from './ProductAddToCartCta.module.css'

type ProductAddToCartButtonProps = {
  loading: boolean
}

export const ProductAddToCartButton: FC<ProductAddToCartButtonProps> = ({
  loading,
}) => {
  const trackAddToCartButton = useProductAddToCartButtonTracking()

  return (
    <LoadingButton
      className={clsx(
        'w-full',
        'whitespace-pre-wrap',
        styles['product-add-to-cart-cta__button'],
      )}
      data-qa-id="add-to-cart-button"
      disabled={loading}
      loading={loading}
      loadingPosition="start"
      onClick={(event) => {
        if (loading) {
          event.preventDefault()
        } else {
          trackAddToCartButton()
        }
      }}
      startIcon={loading ? null : <IconShoppingCart />}
      type="submit"
    >
      <FormattedMessage id="general.button.label.addToCart" />
    </LoadingButton>
  )
}
